import React, { useState } from 'react';
import UsersContext from './UsersContext';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import UsersListSearch from './UsersListSearch';
import UsersListHeader from './UsersListHeader';
import styled from 'styled-components';
import Select from 'react-select';

const listHeaderHeight = 170;

const ListHeaderContainer = styled.div`
    height: ${listHeaderHeight}px
`;

const ListContentContainer = styled.div`
    overflow-y:auto
`;

const SelectContainer = styled.div`
    width:100%;
`;

const ListSubtext = styled.div`
    font-size: 12px;
`


const UsersList = props => {
    // const [isRoleFilterApplied, setIsRoleFilterApplied] = useState(false);
    // const [rolefilterValue, setRolefilterValue] = useState(null);

    const handleUserClick = (context, user) => {
        // Add safety check to prevent errors when clicking during loading
        if (!context || !context.selectUser || !user) {
            return;
        }
        context.cancelEditingUserDetails();
        context.selectUser(user);
    };

    return (<UsersContext.Consumer>
        {context => {

            const filteredUsers = context.filteredUsers ? context.filteredUsers : context.users.users

            let AllRoles = [];
            // get unique roles list 
            context.users.usersRole?.map((userRoles) => {
                let temp = AllRoles.find((role) => role.value === userRoles.name);
                if (!temp) {
                    AllRoles.push({ value: userRoles.name, label: userRoles.name });
                }
            });
            
            return (
                <div>
                    <ListHeaderContainer>
                        <ListItem divider>
                            <UsersListHeader />
                        </ListItem>
                        <ListItem divider>
                            <SelectContainer>
                                <Select
                                    isSearchable={true}
                                    options={[{ value: null, label: "Clear" }, ...AllRoles]} // Include an option for clearing the selection
                                    onChange={selectedRole => {
                                        if (selectedRole && selectedRole.value === null) {
                                            context.updateRoleFilter(null); // Handle the clear selection action
                                        } else {
                                            context.updateRoleFilter(selectedRole);
                                        }
                                    }}
                                    placeholder="Filter by Role"
                                    isMulti={false}
                                    value={context.rolefilter}
                                />

                            </SelectContainer>
                        </ListItem>
                        <ListItem divider>
                            <UsersListSearch
                                searchText={context.searchText}
                                onSearchTextUpdated={searchText => context.updateSearchText(searchText)}
                            />
                        </ListItem>
                    </ListHeaderContainer>
                    <ListContentContainer style={{ height: context.contentHeight - listHeaderHeight }}>
                        <List>

                            {filteredUsers && filteredUsers.map(user =>
                                <ListItem
                                    key={user.id}
                                    divider
                                    selected={context.users.selectedUser && user.id === context.users.selectedUser.id}
                                    button
                                    onClick={() => handleUserClick(context, user)}
                                >
                                    <div>
                                        <ListItemText primary={user.displayName} />
                                        <ListSubtext>({user.bun})</ListSubtext>
                                    </div>
                                </ListItem>)}
                        </List>
                    </ListContentContainer>
                </div>)
        }}
    </UsersContext.Consumer>
    )
}

export default UsersList;   